// app-review.ts
import { AppReview } from '@capawesome/capacitor-app-review';
import { Capacitor } from '@capacitor/core';

const STORAGE_KEY = 'kscolta.lastAppReviewRequest';
const REVIEW_DELAY_DAYS = 5;

function daysSince(dateStr: string | null): number {
  if (!dateStr) return Infinity;
  const past = new Date(dateStr);
  const now = new Date();
  const diffTime = Math.abs(now.getTime() - past.getTime());
  return diffTime / (1000 * 60 * 60 * 24);
}

async function shouldRequestReview(): Promise<boolean> {
  if (!Capacitor.isNativePlatform()) return false;

  const lastRequest = localStorage.getItem(STORAGE_KEY);
  const days = daysSince(lastRequest);

  return days > REVIEW_DELAY_DAYS;
}

async function requestReview(): Promise<void> {
  console.log('[AppReview] requestReview called');
  const canRequest = await shouldRequestReview();
  if (!canRequest) return;

  try {
    console.log('[AppReview] requestReview passed canRequest check');
    await AppReview.requestReview();
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
  } catch (e) {
    console.warn('[AppReview] Failed to request review:', e);
  }
}

export const AppReviewManager = {
  requestReview,
  shouldRequestReview,
};
